import { render, staticRenderFns } from "./CaseStudy.vue?vue&type=template&id=4ebe2f53&scoped=true&"
import script from "./CaseStudy.vue?vue&type=script&lang=js&"
export * from "./CaseStudy.vue?vue&type=script&lang=js&"
import style0 from "./CaseStudy.vue?vue&type=style&index=0&id=4ebe2f53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe2f53",
  null
  
)

export default component.exports